export default "__VITE_ASSET__D8OoI7ex__"